var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7994 15.3374C27.7994 14.3867 27.7074 13.4054 27.5541 12.4854H14.2754V17.9134H21.8807C21.5741 19.6614 20.5621 21.1947 19.0594 22.176L23.5981 25.7027C26.2661 23.2187 27.7994 19.6 27.7994 15.3374Z",
    fill: "#4280EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2745 29.076C18.0772 29.076 21.2665 27.8186 23.5972 25.672L19.0585 22.176C17.8012 23.0346 16.1758 23.5253 14.2745 23.5253C10.5945 23.5253 7.49717 21.0413 6.3625 17.7293L1.70117 21.3173C4.09317 26.0706 8.93851 29.076 14.2745 29.076Z",
    fill: "#34A353"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36336 17.6987C5.7807 15.9507 5.7807 14.0493 6.36336 12.3013L1.70203 8.68268C-0.291302 12.6693 -0.291302 17.3613 1.70203 21.3173L6.36336 17.6987Z",
    fill: "#F6B704"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2745 6.50533C16.2678 6.47466 18.2305 7.24133 19.6718 8.62133L23.6892 4.57333C21.1438 2.18133 17.7705 0.89333 14.2745 0.923997C8.93851 0.923997 4.09317 3.92933 1.70117 8.68266L6.3625 12.3013C7.49717 8.95866 10.5945 6.50533 14.2745 6.50533Z",
    fill: "#E54335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.b45b311f52303954c4353d4405fb8877.svg";
export { ForwardRef as ReactComponent };